// Avatar do user logado (PO1-1976). Mostra:
//   - foto real (user.avatarUrl) se houver — PO1-1918 vai popular esse campo
//   - fallback: círculo colorido com iniciais derivadas de Name+Surname ou
//     primeira letra do email
// A cor de fundo é determinística (hash do nome) pra cada user ter sempre
// a mesma — fica reconhecível.

import React from "react";
import "./UserAvatar.css";

const PALETTE = [
  "#1d8cf8", // azul Flow
  "#00bf9a", // verde GoBid
  "#ff8d72", // laranja Trackfy
  "#e14eca", // magenta Autopilot
  "#fd5d93", // rosa
  "#a78bfa", // lilás
];

function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0; // 32-bit
  }
  return Math.abs(h);
}

// Backend_hub e hub-backend devolvem o user com nomes de campo diferentes;
// tentamos várias variantes antes de cair pro email / username.
function getNameFromUser(user) {
  return (user.Name || user.name || user.firstName || user.givenName || "").trim();
}
function getSurnameFromUser(user) {
  return (user.Surname || user.surname || user.lastName || user.familyName || "").trim();
}
function getDisplayNameFromUser(user) {
  return (user.displayName || user.fullName || user.nome || "").trim();
}
function getEmailFromUser(user) {
  return (user.EmailAddress || user.email || user.Email || "").trim();
}
function getUserNameFromUser(user) {
  return (user.userName || user.UserName || user.username || "").trim();
}

function getInitials(user) {
  if (!user) return "?";

  const name = getNameFromUser(user);
  const surname = getSurnameFromUser(user);
  if (name || surname) {
    const a = name.charAt(0).toUpperCase();
    const b = surname.charAt(0).toUpperCase();
    return (a + b) || a || b || "?";
  }

  const displayName = getDisplayNameFromUser(user);
  if (displayName) {
    const parts = displayName.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  }

  const email = getEmailFromUser(user);
  if (email) {
    const local = email.split("@")[0];
    const parts = local.split(/[._-]/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    return local.substring(0, 2).toUpperCase();
  }

  const userName = getUserNameFromUser(user);
  if (userName) return userName.substring(0, 2).toUpperCase();

  return "?";
}

function getColor(user) {
  if (!user) return PALETTE[0];
  // Hash usa APENAS o email pra garantir cor consistente entre header (que lê
  // o user do JWT) e tela de Perfil (que lê do GET /users/me) — esses dois
  // payloads têm conjuntos de campos diferentes, então seed misto resultava em
  // cores diferentes pro mesmo user.
  const seed = getEmailFromUser(user) || getUserNameFromUser(user) || "default";
  return PALETTE[hashString(seed) % PALETTE.length];
}

const UserAvatar = ({ user, size = 36 }) => {
  const avatarUrl = user && user.avatarUrl;
  if (avatarUrl) {
    return (
      <img
        className="user-avatar user-avatar--img"
        src={avatarUrl}
        alt={getInitials(user)}
        style={{ width: size, height: size }}
      />
    );
  }
  const initials = getInitials(user);
  const bg = getColor(user);
  return (
    <span
      className="user-avatar user-avatar--initials"
      style={{
        width: size,
        height: size,
        background: bg,
        fontSize: Math.round(size * 0.42),
      }}
      aria-label={initials}
    >
      {initials}
    </span>
  );
};

export default UserAvatar;
